import { render, staticRenderFns } from "./CreateVideoPitch.vue?vue&type=template&id=2bc3d4d9"
import script from "./CreateVideoPitch.vue?vue&type=script&lang=js"
export * from "./CreateVideoPitch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports